import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';

import { apiResourceSchema } from '../common/schemas';
import { QueryKeys } from '../keys';
import { request } from '../request';
import { customConditionSchema } from './schemas';

export const customConditionsQueryOptions = queryOptions({
  queryKey: QueryKeys.customConditions.index,
  queryFn: async () => {
    const response = await request('/custom-conditions');

    const { data: customConditions } = apiResourceSchema(customConditionSchema.array()).parse(response);

    return customConditions;
  },
  staleTime: Infinity,
  gcTime: Infinity,
});

export const useCustomConditions = () => {
  return useSuspenseQuery({
    ...customConditionsQueryOptions,
    select: (customConditions) => customConditions.filter((customCondition) => !customCondition.deleted),
  });
};

export const useCustomConditionsWithTrashed = () => {
  return useSuspenseQuery(customConditionsQueryOptions);
};
